import { useClientAsyncInit } from '@statsig/react-bindings';

import { getOldSdkStableIdIfNewNotPresent } from '../../../apps/explore/components/AppWrapper/_app.hacks.ts';
import { getBtfQueryParameters } from '../../../apps/explore/utils/btf';
import { isSSR } from '../../../apps/explore/utils/helpers';
import { SemboMarket } from '../../../apps/explore/utils/markets.ts';

export const useStatsigClient = (market: SemboMarket | undefined) => {
  const statsigSdkKey =
    process.env.NEXT_PUBLIC_STATSIG_ID_PROD ??
    'client-1TcR39BspCjupk333PNurPmnDtKyb2PD1bIyyJldzyb';

  const statsigUser = isSSR()
    ? { custom: { btf: [] } }
    : {
        customIDs: {
          stableID: process.env.NEXT_PUBLIC_STATSIG_ID_PROD
            ? getOldSdkStableIdIfNewNotPresent()
            : undefined,
        },
        custom: {
          btf: [...getBtfQueryParameters(window.location.href)],
          marketHost: market?.host,
        },
      };

  const statsigOptions = {
    environment: {
      tier: process.env.NEXT_PUBLIC_STATSIG_ID_PROD
        ? 'production'
        : 'development',
    },
  };

  return useClientAsyncInit(statsigSdkKey, statsigUser, statsigOptions);
};
